module.exports = __webpack_public_path__ + "ptc_nakagawa_P2.d89c12f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_P2.jpg
// module id = J7pj
// module chunks = 0